<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Management Employee Data Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="field.org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="getAllReport();" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-switch color="#0F2027" v-model="field.employee_code" label="Employee Code"></v-switch>
                    <v-switch color="#0F2027" v-model="field.dateofjoining" label="Joining Date"></v-switch>
                    <v-switch color="#0F2027" v-model="field.iscurrentlyworking" label="Working Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.firstname" label="First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.middlename" label="Middle Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.lastname" label="Last Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.fullname" label="Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth" label="DoB"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bloodgroup" label="Blood Group"></v-switch>
                    <v-switch color="#0F2027" v-model="field.aadhar_no" label="Aadhar No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mobile_no" label="Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.alternate_mobile_no" label="Alternate Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.telephone_no" label="Telephone No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_name" label="Emergency Contact Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_address" label="Emergency Contact Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_number" label="Emergency Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_place" label="Birth Place"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_address" label="Birth Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_full_name" label="Father Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_first_name" label="Mother First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.physicallyhandicapped_details" label="Physically Handicapped Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.isphysicallyhandicapped" label="Is physically Handicapped"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth_in_words" label="Date Of Birth In Words"></v-switch>
                    <v-switch color="#0F2027" v-model="field.highest_qualification" label="Highest Qualification"></v-switch>
                    <v-switch color="#0F2027" v-model="field.personal_email" label="Personal Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.institute_email" label="Institute Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.gender" label="Gender"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birthcountry" label="Birth Country"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mothertoungue" label="Mother Toungue"></v-switch>
                    <v-switch color="#0F2027" v-model="field.teaching_exp" label="Teaching Experience"></v-switch>
                    <v-switch color="#0F2027" v-model="field.training" label="Training"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank" label="Bank Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank_ifsc_code" label="IFSC"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank_account_no" label="Bank Account no"></v-switch>
                    <v-switch color="#0F2027" v-model="field.pf_no" label="PF"></v-switch>
                    <v-switch color="#0F2027" v-model="field.spouse_name" label="Spouse Name"></v-switch>
                </v-row>
            </v-col>
            <div v-if="org_data_list!=''">
                <v-btn rounded color="success" outlined @click="ExportToExcel();" :loading="exs_loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th v-for="(hl, index) in header_list" :key="index">
                                        {{ hl.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(fl, index) in org_data_list" :key="index">
                                    <td v-for="(hl, index1) in header_list" :key="index1">{{fl[hl.value]}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                all_toggle: false,
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                header: null,
                standard_list: null,
                dision_list: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,
                field: {
                    employee_code: false,
                    firstname: false,
                    middlename: false,
                    lastname: false,
                    fullname: false,
                    date_of_birth: false,
                    bloodgroup: false,
                    aadhar_no: false,
                    mobile_no: false,
                    alternate_mobile_no: false,
                    telephone_no: false,
                    emergency_contact_name: false,
                    emergency_contact_address: false,
                    emergency_contact_number: false,
                    birth_place: false,
                    birth_address: false,
                    father_full_name: false,
                    mother_first_name: false,
                    physicallyhandicapped_details: false,
                    isphysicallyhandicapped: false,
                    date_of_birth_in_words: false,
                    highest_qualification: false,
                    personal_email: false,
                    institute_email: false,
                    gender: false,
                    birthcountry: false,
                    mothertoungue: false,
                    dateofjoining: false,
                    teaching_exp: false,
                    iscurrentlyworking: false,
                    training: false,
                    bank: false,
                    bank_ifsc_code: false,
                    bank_account_no: false,
                    pf_no: false,
                    spouse_name: false,
                    dataTable: null,
                    div: null,
                    std_id: "",
                    org: "",
                    exs_loader: false,
                },
                header_list: [],
            };
        },
        watch: {
            all_toggle() {
                console.log(this.all_toggle);
                var keys = Object.keys(this.field);
                for (let i = 0; i < keys.length; i++)
                    if (this.field[keys[i]] == false || this.field[keys[i]] == true) {
                        this.field[keys[i]] = this.all_toggle;
                    }
            },
        },
        methods: {
            ExportToExcel() {
                this.exs_loader = true;
                var htmltable = document.getElementById("my-table-id");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
                this.exs_loader = false;
            },
            clear() {
                this.org_data_list = [];
            },
            getAllReport() {
                this.fetch_loader = true;
                axios
                    .post("/Management/getInstructorReport", this.field)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_data_list = res.data.org_data;
                            this.header_list = res.data.header_list;
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        //close loader
                        this.fetch_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: center;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
